import packageJson from '../../package.json';

console.log(`%c ${process.env.VUE_APP_SYS_NAME} v ${packageJson.version}`, 'color: #99c868; font-size: 40px; font-family: Impact; text-transform: uppercase; line-height: 2.4; border: 2px dotted #99c868; padding: 10px 20px;');

